import { ApiProblemError } from '@taler/api-client'

/** The server's own detail message when there is one, so a validation reason survives to the UI. */
export function problemDetail(error: Error | null): string | undefined {
  return error instanceof ApiProblemError ? error.problem.detail : undefined
}

/** The error's stable code, when it is one - lets a screen react to a specific outcome
 * (e.g. `import.preview_entry_missing_account`) rather than pattern-matching on prose. */
export function problemCode(error: Error | null): string | undefined {
  return error instanceof ApiProblemError ? error.problem.code : undefined
}
